import { inject} from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

export const ContactIdGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const contactID = route.params['contactID'];
  if (contactID && !isNaN(Number(contactID))) {
    return true;
  }
  // Redirect to Contact-Search or Recent if not a number
  return inject(Router).createUrlTree(['/Contact-Search']);
};
